package eric.bitria.samples

/** Destinations in the samples app. */
sealed class Screen {
    data object Home : Screen()
    data object Duck : Screen()
    data object Primitives : Screen()
    data object Lighting : Screen()
    data object Picking : Screen()
    data object Labels : Screen()
    data object CameraTour : Screen()
    data object Capture : Screen()
    data object Solar : Screen()
    data object Animation : Screen()
    data object SplitView : Screen()
    data object Texture : Screen()
    data object KTXEnvironment : Screen()
    data object HDREnvironment : Screen()
    data object Transparent : Screen()
    data object RuntimeMaterial : Screen()
}
